class StringManipulator {
  static replaceCharWithSpace (str) {
    return str.replace(/_/g, " ");
  }
}

export default StringManipulator;